import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  saveTaskCallback,
  updateTaskStep4Callback
} from 'Pages/Task/recoil/callbacks/callbacks'
import { pageState, step4IsEnabledState } from 'Pages/Task/recoil/state/page'
import { taskState } from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import PanelConditios from './components/PanelConditios'
import PanelExcetpions from './components/PanelExcetpions'
import PanelFrequency from './components/PanelFrequency'

const TaskStep4 = () => {
  const intl = useIntl()
  const step4IsEnabled = useRecoilValue(step4IsEnabledState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const saveTask = useRecoilCallback(saveTaskCallback, [])
  const updateTaskStep4 = useRecoilCallback(updateTaskStep4Callback, [])
  const { idTask } = useRecoilValue(pageState)
  const task = useRecoilValue(taskState)

  const handleBack = () => {
    changeWizardStep(3)
  }

  const handleConfirm = () => {
    updateTaskStep4()
  }

  useEffect(() => {
    if (task.saveTask) {
      if (idTask > 0) {
        saveTask(false)
      } else {
        const save = async () => {
          const res = await saveTask(false)
          if (res) {
            changeWizardStep(5)
          }
        }
        save()
      }
    }
  }, [task.saveTask])

  return (
    <>
      <PanelFrequency />
      <PanelExcetpions />
      <PanelConditios />

      <Flex justifyContent='space-between'>
        <Button
          data-mu-test='task-4-btn-back'
          kind={BUTTON_VARIANT_SECONDARY}
          disabled={idTask > 0 && !step4IsEnabled}
          onClick={() => handleBack()}
        >
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>
        <FlexItem>
          <Button
            data-mu-test={idTask > 0 ? 'task-4-btn-update' : 'task-4-btn-save'}
            kind={BUTTON_VARIANT_PRIMARY}
            onClick={() => handleConfirm()}
            disabled={!step4IsEnabled}
          >
            {idTask > 0
              ? intl.formatMessage({ id: 'Load.Task.SaveTask' })
              : intl.formatMessage({ id: 'Load.Task.SaveAndRecap' })}
          </Button>
        </FlexItem>
      </Flex>
    </>
  )
}

export default TaskStep4
